export const environment = {
  env: "stage",
  production: false,
  apiBaseUrl: "https://api.stage.mana-vi.ck1lab.net",
  s3Url: "https://stage.mana-vi.ck1lab.net/",
  cfVideoBase: "https://stage.mana-vi.ck1lab.net/",
  encryptionKey: "MaNaVi@2026!Stage!Encryption!AES256!Key#P3wN7mQ1xL9vK5zR8bH2cF4jT6yS0eD"
};
